<script>
    export let path = ''
    export let options = {}
    import { useNavigate } from 'svelte-navigator'
    import { onMount, tick } from 'svelte'
    const navigate = useNavigate()
    onMount(async (_) => {
        await tick()
        await navigate(path, { ...options, replace: true })
    })
    // onMount(_ => {
    //     navigate(path, options);
    // })
</script>
